import { isEmpty, isNullOrUndef } from 'utils';

export default function isNullOrUndefOrEmpty(value) {
  return (isEmpty(value) || isNullOrUndef(value));
}
